const quickOrder = {
  searchPlaceholder: "Product code",
  notFound: "No product found",
  addedToCart: "Item added to cart",
};

export { quickOrder };
